
import React, { FunctionComponent } from "react";

import { UpdatePageModel } from "../UpdatePageModel";
import { pluralize } from "services/Utils";

interface NotificationsCardProps {
    model: UpdatePageModel,
    onClick: () => void,
}

export const NotificationsCard: FunctionComponent<NotificationsCardProps> = function NotificationsCard(props) {
    const { model, onClick } = props;
    const { update } = model;

    return (<div className="update_card clickable" onClick={onClick}>
        <div className="update_card_title ellipsis">
            Notifications
        </div>
        <div>
            <b>{update.requestedApproverIDs?.length || 0}</b>&nbsp;
            {pluralize(update.requestedApproverIDs?.length, 'requested approver', 'requested approvers')}
        </div>
        <div>
            <b>{update.notificationEmails?.length || 0}</b>&nbsp;
            {pluralize(update.notificationEmails?.length, 'email ', 'emails ')}
            will be sent status updates
        </div>
    </div>);
}